import emojiRegex from 'emoji-regex';
/**
 * Foo Bar => FooBar
 * foo-bar => fooBar
 * --foo--bar => FooBar
 * __foo__bar => FooBar
 * @param name
 */
export function camelCase(name) {
    var camelPattern = /[-_\s]+([a-zA-Z])/gi;
    return name
        .replace(camelPattern, function (_, c) { return c.toUpperCase(); });
}
/**
 * 把单词变成首字母大写其余字母小写的形式
 * @param str
 */
export function capitalize(str) {
    return str[0].toUpperCase() + str.slice(1).toLowerCase();
}
/**
 * (str) -> int|float
 *
 * 英文字被当作半个字符时的长度
 *
 * 实际使用中，一般设计会认为中文字符如'啊','哦','额','，'等理解为两个长度，英文字符和数字如'a','1',',' 等理解为一个长度，所以此方法可以获取他们认为的字符串长度（注意，不是字符串的真是长度，只是设计师理解的长度）
 *
 * @param str
 */
export function getStrViewLength(str) {
    var length = 0;
    // 为了把 emoji 的字符长度都算作 2，先把所有 emoji 都统一替换为 1 个中文字
    var _str = str.replace(emojiRegex(), '豆');
    for (var _i = 0, _str_1 = _str; _i < _str_1.length; _i++) { // 注意使用 for of 可以正确遍历字符串的长度，而其他方法会将"𠮷"当成两个长度遍历
        var s = _str_1[_i];
        var codePoint = s.codePointAt(0);
        if (codePoint && codePoint > 0x00FF) {
            // 不管是两个字节的字符如'啊'，还是四个字节的字符'𠮷'，都'当成'是属于两个字符长度的范围
            length = length + 2;
        }
        else {
            length++;
        }
    }
    // 返回结果时，再统一除以 2
    return length / 2;
}
//# sourceMappingURL=words.js.map